import React from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { getComparatorSort, isFieldRequired } from "../../../helpers";
import { LIST_NULL_OPTION_VALUE } from "../../../helpers/constant";

const AppSelect = ({ label, name, value, error, touched, options, labelKey, valueKey, ...props }) => {
    const isRequired = props.validationSchema ? isFieldRequired(props.validationSchema, name) : false;

    // alphabetical sort
    // Memoize sorted data to avoid re-sorting on each render
    const sortedOptions = React.useMemo(() => {
        return [...options].sort(getComparatorSort('desc', labelKey));
    }, [options, labelKey]);

    const selectId = props.htmlId || name;
    const labelId = `${selectId}-label`;

    return (
        <FormControl fullWidth variant="outlined" required={isRequired} sx={props.sx} error={touched && !!error}
            size={props.size} disabled={props.disabled}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                labelId={labelId}
                id={selectId}
                name={name}
                label={label}
                value={value}
                onChange={props.onChange}
                onBlur={props.onBlur}
                error={touched && !!error}
                disabled={props.disabled}
            >
                {props.Placeholder ? <MenuItem value={LIST_NULL_OPTION_VALUE} key={"null-value-option"}>{props.Placeholder}</MenuItem> : ""}
                {sortedOptions.map((option, zid) => (
                    <MenuItem key={zid} value={valueKey ? option[valueKey] : option} name={valueKey ? option[valueKey] : option}>
                        {labelKey ? option[labelKey] : option}
                    </MenuItem>
                ))}
            </Select>
            {touched && error && <FormHelperText error>{error}</FormHelperText>}
        </FormControl>
    );
};

export default AppSelect;